<template>

    <div v-if="!app.device.isMobile">

      <div class="columns">
        <div class="column" :class="[cartChoices.length || cartGuestChoices.length || savedItems.length || checkedoutOrders.length ? 'is-8 left-view':'is-12']">
          <div class="tile is-vertical" >
              <div class="tile is-child is-parent">
                  <transition name="component-fade" mode="out-in">
                      <component
                              :is="mainView"
                              :candidates="candidates"
                              :categoryId="selectedCategory"
                              :offerId="selectedOffer">
                      </component>
                  </transition>
              </div>
          </div>
        </div>

        <div class="column is-4" v-if="cartChoices.length || cartGuestChoices.length || savedItems.length || checkedoutOrders.length">
          <transition name="slide-fade" mode="out-in">
            <div class="tile is-parent right-view sticky-cart" >
              <component
                  :is="cartView"
                  :candidates="candidates">
              </component>
            </div>
          </transition>
        </div>

      </div>
    </div>

    <div class="tile is-ancestor" v-else>


        <transition name="slide-fade" mode="out-in" >
            <div class="tile is-parent is-child" v-if="cartChoices.length || cartGuestChoices.length || savedItems.length || checkedoutOrders.length">
                <component
                        :is="cartView"
                        :candidates="candidates">
                </component>
            </div>
        </transition>

        <div class="tile is-vertical" :class="[cartChoices.length || cartGuestChoices.length || savedItems.length || checkedoutOrders.length ? '':'']">

            <div class="tile is-parent is-child">
                <transition name="component-fade" mode="out-in">
                    <component
                            :is="mainView"
                            :candidates="candidates"
                            :categoryId="selectedCategory"
                            :offerId="selectedOffer">
                    </component>
                </transition>
            </div>
        </div>
    </div>

</template>

<script>

    import Categories from './Categories'
    import Category from './Category'
    import Offer from './Offer'
    import Cart from './cart/Cart'
    import {mapGetters, mapState} from 'vuex'

    export default {
        data () {
            return {
                mainView: Categories,
                cartView: Cart,
                categories: [],
                selectedCategory: 0,
                selectedOffer: 0
            }
        },
        props: {
            candidates: { type: Array }
        },
        computed: {
            ...mapState({
                app: 'app'
            }),
            ...mapGetters('orders', [
                'cartChoices',
                'cartGuestChoices',
                'savedItems',
                'checkedoutOrders'
            ]),
        },
        watch: {
            '$route'(to, from) {
                if (to.name === 'highschool-categories' || to.name === 'eshop-categories') {
                    this.mainView = Categories
                }
                if (to.name === 'highschool-category' || to.name === 'eshop-category') {
                    this.selectedCategory = parseInt(to.params.categoryId)
                    this.mainView = Category
                }
                if (to.name === 'highschool-offer' || to.name === 'eshop-offer') {
                    this.selectedOffer = parseInt(to.params.offerId)
                    this.selectedCategory = parseInt(to.params.categoryId)
                    this.mainView = Offer
                }
            }
        },
        created() {
            if (this.$route.name === 'highschool-category' || this.$route.name === 'eshop-category') {
                this.selectedCategory = parseInt(this.$route.params.categoryId)
                this.mainView = Category
            }
            if (this.$route.name === 'highschool-offer' || this.$route.name === 'eshop-offer') {
                this.selectedOffer = parseInt(this.$route.params.offerId)
                this.selectedCategory = parseInt(this.$route.params.categoryId)
                this.mainView = Offer
            }

        }
    }
</script>

<style scoped>
.sticky-cart {
  position: sticky;
  top: 3em;
  z-index: 1000;
}

</style>
